"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleCategoryApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var ArticleCategoryApi = /** @class */ (function () {
    function ArticleCategoryApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询文章分类,添加文章分类
     * @method GET 查询文章分类
     * @method POST 添加文章分类
     *
     */
    ArticleCategoryApi.prototype.ArticleCategory = function () {
        return this.http
            .url("/api/ArticleCategory")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    /**
     * 修改文章分类,删除文章分类
     * @method PUT 修改文章分类
     * @method DELETE 删除文章分类
     *
     * @params id 无说明
     */
    ArticleCategoryApi.prototype.ArticleCategoryById = function (id) {
        return this.http
            .url("/api/ArticleCategory/" + id)
            .addSecurityHeaders()
            .support('PUT', 'DELETE');
    };
    ArticleCategoryApi.diOptions = di_1.default.options({
        name: "ArticleCategoryApi",
        scope: "Singleton"
    });
    return ArticleCategoryApi;
}());
exports.ArticleCategoryApi = ArticleCategoryApi;
exports.default = ArticleCategoryApi;
